/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/data';
import '../../customers/request';
import '../../common/currency';

const $root =
  $protobuf.roots['default'] ||
  ($protobuf.roots['default'] = new $protobuf.Root());

const jsonData = {
  squareup: {
    nested: {
      buyerportal: {
        nested: {
          receiptlookup: {
            nested: {
              CreateReceiptLookupVerificationRequest: {
                fields: {
                  verificationCredential: {
                    type: '.squareup.buyerportal.common.VerificationCredential',
                    id: 1,
                    rule: 'optional',
                  },
                  idempotencyKey: {
                    type: 'string',
                    id: 2,
                    rule: 'optional',
                  },
                },
              },
              CreateReceiptLookupVerificationResponse: {
                fields: {
                  status: {
                    type: '.squareup.customers.request.RequestStatus',
                    id: 1,
                    rule: 'optional',
                  },
                  errors: {
                    type: '.squareup.customers.request.RequestError',
                    id: 2,
                    rule: 'repeated',
                  },
                },
              },
              VerifyReceiptLookupCodeRequest: {
                fields: {
                  verificationCredential: {
                    type: '.squareup.buyerportal.common.VerificationCredential',
                    id: 1,
                    rule: 'optional',
                  },
                  verificationCode: {
                    type: 'string',
                    id: 2,
                    rule: 'optional',
                  },
                },
              },
              VerifyReceiptLookupCodeResponse: {
                fields: {
                  status: {
                    type: '.squareup.customers.request.RequestStatus',
                    id: 1,
                    rule: 'optional',
                  },
                  errors: {
                    type: '.squareup.customers.request.RequestError',
                    id: 2,
                    rule: 'repeated',
                  },
                },
              },
              ReceiptLookupPayment: {
                fields: {
                  paymentToken: {
                    type: 'string',
                    id: 1,
                    rule: 'optional',
                  },
                  merchantName: {
                    type: 'string',
                    id: 2,
                    rule: 'optional',
                  },
                  totalAmount: {
                    type: '.squareup.common.Money',
                    id: 3,
                    rule: 'optional',
                  },
                },
              },
              SearchReceiptsRequest: {
                fields: {
                  nonce: {
                    type: 'string',
                    id: 1,
                    rule: 'optional',
                  },
                  amount: {
                    type: 'int64',
                    id: 2,
                    rule: 'optional',
                  },
                  currencyCode: {
                    type: 'string',
                    id: 3,
                    rule: 'optional',
                  },
                  dateSubmit: {
                    type: 'string',
                    id: 4,
                    rule: 'optional',
                  },
                  offset: {
                    type: 'int32',
                    id: 5,
                    rule: 'optional',
                  },
                  recaptchaToken: {
                    type: 'string',
                    id: 6,
                    rule: 'optional',
                  },
                },
              },
              SearchReceiptsResponse: {
                fields: {
                  payments: {
                    type: '.squareup.buyerportal.receiptlookup.ReceiptLookupPayment',
                    id: 1,
                    rule: 'repeated',
                  },
                  status: {
                    type: '.squareup.customers.request.RequestStatus',
                    id: 2,
                    rule: 'optional',
                  },
                  errors: {
                    type: '.squareup.customers.request.RequestError',
                    id: 3,
                    rule: 'repeated',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

// Do not initialize these protos if they have already been defined
if (
  !$root.nested?.squareup?.nested?.buyerportal?.nested?.receiptlookup?.nested
    ?.CreateReceiptLookupVerificationRequest &&
  !$root.nested?.squareup?.nested?.buyerportal?.nested?.receiptlookup?.nested
    ?.CreateReceiptLookupVerificationResponse &&
  !$root.nested?.squareup?.nested?.buyerportal?.nested?.receiptlookup?.nested
    ?.VerifyReceiptLookupCodeRequest &&
  !$root.nested?.squareup?.nested?.buyerportal?.nested?.receiptlookup?.nested
    ?.VerifyReceiptLookupCodeResponse &&
  !$root.nested?.squareup?.nested?.buyerportal?.nested?.receiptlookup?.nested
    ?.ReceiptLookupPayment &&
  !$root.nested?.squareup?.nested?.buyerportal?.nested?.receiptlookup?.nested
    ?.SearchReceiptsRequest &&
  !$root.nested?.squareup?.nested?.buyerportal?.nested?.receiptlookup?.nested
    ?.SearchReceiptsResponse
) {
  $root.addJSON(jsonData);
}

/**
 * Sends a one-time verification code to the provided email or phone. This is an unauthenticated
 * endpoint used by the account-less receipt lookup flow.
 *
 * SOURCE CreateReceiptLookupVerificationRequest @ squareup/buyerportal/receiptlookup/data.proto at 16:1
 */
export const CreateReceiptLookupVerificationRequest = $root.lookupType(
  'squareup.buyerportal.receiptlookup.CreateReceiptLookupVerificationRequest'
);
fixType(CreateReceiptLookupVerificationRequest, {
  verificationCredential: { required: true },
  idempotencyKey: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(CreateReceiptLookupVerificationRequest);
/**
 * SOURCE CreateReceiptLookupVerificationResponse @ squareup/buyerportal/receiptlookup/data.proto at 24:1
 */
export const CreateReceiptLookupVerificationResponse = $root.lookupType(
  'squareup.buyerportal.receiptlookup.CreateReceiptLookupVerificationResponse'
);
fixType(CreateReceiptLookupVerificationResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(CreateReceiptLookupVerificationResponse);
/**
 * Verifies the provided code against the credential. On success, mints a short-lived proof and sets
 * an HttpOnly proof cookie that authorizes a subsequent receipt search. This is an unauthenticated
 * endpoint.
 *
 * SOURCE VerifyReceiptLookupCodeRequest @ squareup/buyerportal/receiptlookup/data.proto at 32:1
 */
export const VerifyReceiptLookupCodeRequest = $root.lookupType(
  'squareup.buyerportal.receiptlookup.VerifyReceiptLookupCodeRequest'
);
fixType(VerifyReceiptLookupCodeRequest, {
  verificationCredential: { required: true },
  verificationCode: { required: true },
});
Builder.createAndAttachToType(VerifyReceiptLookupCodeRequest);
/**
 * SOURCE VerifyReceiptLookupCodeResponse @ squareup/buyerportal/receiptlookup/data.proto at 39:1
 */
export const VerifyReceiptLookupCodeResponse = $root.lookupType(
  'squareup.buyerportal.receiptlookup.VerifyReceiptLookupCodeResponse'
);
fixType(VerifyReceiptLookupCodeResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(VerifyReceiptLookupCodeResponse);
/**
 * A single payment/receipt match returned by the account-less receipt search.
 *
 * SOURCE ReceiptLookupPayment @ squareup/buyerportal/receiptlookup/data.proto at 45:1
 */
export const ReceiptLookupPayment = $root.lookupType(
  'squareup.buyerportal.receiptlookup.ReceiptLookupPayment'
);
fixType(ReceiptLookupPayment, {
  totalAmount: { required: true },
});
Builder.createAndAttachToType(ReceiptLookupPayment);
/**
 * Searches for receipts matching a card (nonce), amount, and date. Gated by the `rlv` proof cookie
 * minted by VerifyReceiptLookupCode plus reCAPTCHA. This is an unauthenticated endpoint.
 *
 * SOURCE SearchReceiptsRequest @ squareup/buyerportal/receiptlookup/data.proto at 56:1
 */
export const SearchReceiptsRequest = $root.lookupType(
  'squareup.buyerportal.receiptlookup.SearchReceiptsRequest'
);
fixType(SearchReceiptsRequest, {
  nonce: { required: true },
  amount: { required: true },
  currencyCode: { required: true, notEmpty: true },
});
Builder.createAndAttachToType(SearchReceiptsRequest);
/**
 * SOURCE SearchReceiptsResponse @ squareup/buyerportal/receiptlookup/data.proto at 71:1
 */
export const SearchReceiptsResponse = $root.lookupType(
  'squareup.buyerportal.receiptlookup.SearchReceiptsResponse'
);
fixType(SearchReceiptsResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(SearchReceiptsResponse);
